import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-gif',
  templateUrl: './search-gif.component.html',
  styleUrls: ['./search-gif.component.scss']
})
export class SearchGifComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
